import { readonly, ref } from 'vue'

export type AppNotificationTone = 'success' | 'error' | 'warning' | 'info'

export interface AppNotification {
  id: number
  tone: AppNotificationTone
  message: string
}

const notifications = ref<AppNotification[]>([])
let nextNotificationId = 1

function dismiss(id: number): void {
  notifications.value = notifications.value.filter((item) => item.id !== id)
}

function show(tone: AppNotificationTone, message: string, timeoutMs = 3500): number {
  const id = nextNotificationId++
  notifications.value = [...notifications.value, { id, tone, message }]
  window.setTimeout(() => dismiss(id), timeoutMs)
  return id
}

export function useAppNotification() {
  return {
    notifications: readonly(notifications),
    success: (message: string) => show('success', message),
    error: (message: string) => show('error', message),
    warning: (message: string) => show('warning', message),
    info: (message: string) => show('info', message),
    dismiss,
  }
}
